/// <reference path="../../BaseNew/GAdmSeznamBase.ts"/>

namespace Gordic.Adm.WebControls {
    @Decorators.gcontent
    export class SeznamAdmBudova extends GContentBase<SeznamAdmBudovaObj> {
        private seznamObj: SeznamAdmBudovaObj & GContent;

        onContentReady() {
            this.seznamObj = $.extend(this as GContent, new SeznamAdmBudovaObj());
            this.seznamObj.createBase({
                content: this,
                contentName: "seznamAdmBudovaNew",
                contentCaption: "jres:33001054",  //RC 33001054 : Budovy
                dataListDescriptor: this.dataListDescription,
                comparatorSettings: {
                    itemTemplate: "{ico} - {budova_kod}"
                },
                gridSettings: {
                    columnOrder: `ico,budova_kod,budova_naz,poznamka,dat_od,dat_do,dat_zmena,zmenu_prov_txt`
                }
            })
            this.seznamObj.createBaseMenuBarActions();
            this.seznamObj.createFilter();
            this.seznamObj.createGrid();
        }
    }

    export class SeznamAdmBudovaObj extends GAdmSeznamBase {

        create() {

        }

        openDetail(data: any, isNew: boolean) {
            const cntInitializer = ["Gordic.Adm.WebControls.DetailAdmBudova", {
                currentFilter: this.filterData,
                gridRc: new Gordic.Components.GridRC(this.grid),
                openDialog: this.tabOpen
            }]
            const inputParams = {
                ID: "DetailAdmBudova",
                newRecord: isNew,
                ico: isNew == true ? null : data.ico,
                budova_kod: isNew == true ? null : data.budova_kod
            }
            this.openDialogOrModalWindow(cntInitializer, inputParams);
        }

        createActions(): { [akceName: string]: GAction | GActionParamsDefObj } | null {
            return {
                actOpenSegmentyBudovy: {
                    caption: "jres:33001062", //RC 33001062 : Segmenty budovy
                    icon: "fa-link",
                    run: (ev, ctx) => {
                        this.actOpenSegmentyBudovy()
                    }
                }
            }
        }

        createBaseMenuBarActions() {
            this.cnt.menuBar(this.cnt.actions.createBar(["actOpenDetail*", "actNewDetail*", "actAddToComparison*", "actOpenDialogVyberovaSkupina*",
                {
                    favorite: true, type: "static", caption: "jres:33000138", icon: "fa-link", children: [
                        { action: this.cnt.actions.actOpenSegmentyBudovy }
                    ]
                }
            ]))
        }

        createContextMenu(): MenuParams[] {
            return this.cnt.actions.createBar([
                "actOpenDetail*",
                "actOpenDialogVyberovaSkupina*",
                "-",
                "actOpenSegmentyBudovy"
            ])
        }

        createFilterForm() {
            
        }

        userhardDefaultFilter(hardFilter: any): any {
            return hardFilter;
        }

        collectData(data: any) {
          
        }

        applydata(filterData: any) {
            this.cnt.beginOperation();
            this.cnt.isl.AdmBudova.list({
                filters: filterData
            }).getView().done((data) => {
                this.view = data;
                this.setPlatnostColumn(this.view);
                this.grid.ggrid('setData', this.view);
            }).always(() => { this.cnt.endOperation() });
        }

        selectionGridAct(objArr: IGGridSelection<any>) {

        }

        getSxs(data): IGAdmGridSxs {
            return {
                sxs: `${data.ico}#${data.budova_kod}#`,
                nazev: data["budova_naz"]
            }
        }

        private actOpenSegmentyBudovy() {
            var activeRow = this.grid.ggrid("activeRow");
            if (activeRow)
                $.content().navigate(["Gordic.Adm.WebControls.SeznamAdmSegmentBudovy"], {
                    ID: "SeznamAdmSegmentBudovy",
                    ico: activeRow.ico,
                    budova_kod: activeRow.budova_kod
                })
        }
    }
}